import { fetchConToken } from '../helpers/fetch';

const EstadisticasMiOspedycService = {
    getGenerales : (fechaDesde, fechaHasta) => {
        return fetchConToken(`EstadisticasMiOspedyc/Generales?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`, {}, 'GET')
    },
    getUsuarios : () => {
        return fetchConToken(`EstadisticasMiOspedyc/Usuarios`, {}, 'GET')
    },
    getTurnos : () => {
        return fetchConToken(`EstadisticasMiOspedyc/Turnos`, {}, 'GET')
    },
    cargar : (idEstadistica, data) => {
        return fetchConToken(`EstadisticasMiOspedyc/CargarPorUsuario/${idEstadistica}`, data, 'POST')
    },
}

export {EstadisticasMiOspedycService as default}